module.exports = __webpack_public_path__ + "static/img/miles_pictgrid3_800x794.5730da4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/miles_pictgrid3_800x794.jpg
// module id = +BsS
// module chunks = 0